// extracted by mini-css-extract-plugin
module.exports = {"button":"ol","primary":"om","disabled":"on"};